import { Controller } from '@hotwired/stimulus';
import fetchTurboFrame from '../utils';

export default class extends Controller {
  static targets = [
    'form',
    'artworkRows',
    'inputHeading',
    'colorCount',
    'disciplineSelect',
    'subTypeWrapper',
  ];

  addRow() {
    const tbody = this.artworkRowsTarget;
    const allRows = tbody.querySelectorAll('tr');
    // Get the second-to-last row (last artwork row, before the total row)
    const lastRow = allRows.length > 1 ? allRows[allRows.length - 2] : null;

    if (lastRow) {
      const newRow = lastRow.cloneNode(true);
      // New row index (excluding total row)
      const newIndex = allRows.length - 1;

      // Clear all input values and update ids in the new row
      newRow.querySelectorAll('input, select').forEach((input) => {
        if (input.id) {
          input.id = input.id.replace(/_\d+_/, `_${newIndex}_`);
        }
        if (input.tagName === 'SELECT') {
          input.selectedIndex = 0;
        } else {
          input.value = '';
        }
      });

      // Set $0.00 placeholder for price cells
      const priceCells = newRow.querySelectorAll('.fs-3');
      priceCells.forEach((cell) => {
        cell.textContent = '$0.00';
      });

      // Insert before the total row (last row)
      const totalRow = tbody.querySelector('tr:last-child');
      tbody.insertBefore(newRow, totalRow);
    }
  }

  updateDiscipline() {
    const adminNamespace = this.formTarget.action.includes('/admin/')
      ? '/admin'
      : '';

    if (this.hasSubTypeWrapperTarget) {
      const isDigital =
        this.hasDisciplineSelectTarget &&
        this.disciplineSelectTarget.value === 'Digital';
      this.subTypeWrapperTarget.classList.toggle('d-none', !isDigital);
    }

    // Changing discipline or sub-type changes which upcharges are offered, so the
    // current selections are dropped and the server re-applies its defaults.
    fetchTurboFrame(
      `${adminNamespace}/quotes/new?${this.quoteParams({
        includeOptionPrices: false,
      })}`
    );
  }

  quoteParams({ includeOptionPrices = true } = {}) {
    const params = new URLSearchParams();

    const customer = this.formTarget.querySelector(
      'select[name="quote[customer_id]"]'
    );
    if (customer) {
      params.append('quote[customer_id]', customer.value);
    }

    const disciplineSelect = this.formTarget.querySelector(
      'select[name="quote[discipline]"]'
    );
    if (disciplineSelect) {
      params.append('quote[discipline]', disciplineSelect.value);
    }

    const subTypeSelect = this.formTarget.querySelector(
      'select[name="quote[sub_type]"]'
    );
    if (subTypeSelect && subTypeSelect.value) {
      params.append('quote[sub_type]', subTypeSelect.value);
    }

    const tbody = this.artworkRowsTarget;
    tbody.querySelectorAll('tr:not(:last-child)').forEach((row) => {
      const colorInput = row.querySelector(
        'input[name="quote[artworks_attributes][][color_count]"], select[name="quote[artworks_attributes][][color_count]"]'
      );
      const garmentInput = row.querySelector(
        'input[name="quote[artworks_attributes][][garment_count]"]'
      );
      params.append(
        'quote[artworks_attributes][][color_count]',
        colorInput ? colorInput.value : ''
      );
      params.append(
        'quote[artworks_attributes][][garment_count]',
        garmentInput ? garmentInput.value : ''
      );
    });
    if (includeOptionPrices) {
      this.formTarget
        .querySelectorAll(
          'input[type="checkbox"][name="quote[option_price_ids][]"]:checked'
        )
        .forEach((input) => {
          params.append('quote[option_price_ids][]', input.value);
        });
    }

    return params;
  }
}
